import React, { useEffect } from 'react';
// import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { reactSelectCustomStyle } from 'helper';
import { useDispatch, useSelector } from 'react-redux';
// import { createSelector } from 'reselect';
import { GET_CITIZENSHIP } from '../constant';
import * as actions from '../action';

const selectList = ({ api }, name) => {
  return _.get(api, `${GET_CITIZENSHIP}/${name}.list`) || [];
};

// const makeListSelector = () =>
//   createSelector(
//     ({ api }, name) => _.get(api, `${GET_CITIZENSHIP}/${name}.list`) || [],
//   );

const formatOptions = (data) => {
  return data.map((item) => {
    return {
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'attributes.code'),
      fullInfo: item,
    };
  });
};

const Citizenship = ({ name, onChange, value, readOnly }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    ({ api }) => api.loading.indexOf(`${GET_CITIZENSHIP}/${name}`) > -1
  );
  const list = useSelector((state) => selectList(state, name));
  const options = [
    { label: 'Philippines', value: 'PHL' },
    ...formatOptions(list),
  ];

  const findValue =
    options.find((item) => _.get(item, 'fullInfo.attributes.code') === value) ||
    '';

  useEffect(() => {
    dispatch(actions.getCitizenshipList(name, { code: value, per_page: 9999 }));
  }, [value]);

  // const handleChange = (data) => {
  //   onChange({
  //     target: {
  //       name,
  //       value: data?.value || '',
  //     },
  //   });
  // };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      actions.getCitizenshipList(name, { q: inputValue }, (response) => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      name={name}
      styles={reactSelectCustomStyle}
      isClearable
      isLoading={isLoading}
      placeholder="- Select -"
      value={findValue}
      onChange={onChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

Citizenship.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

Citizenship.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default Citizenship;
